<template>
  <now-playing-section-layout :compact-on-mobile="compactOnMobile">
    <now-playing-image
      slot="now-playing-image"
      :image-src="nowPlayingImageSrc"
      :width="rectangleImageWidth"
      :height="rectangleImageHeight"
      :compact-on-mobile="compactOnMobile"
    >
    </now-playing-image>
    <now-playing-detail
      slot="now-playing-detail"
      :station="station"
      :dark-theme="darkTheme"
      :show-title="showTitle"
      :episode-name="episodeName"
      :episode-description="episodeDescription"
      :episode-audio-file-src="episodeAudioFileSrc"
      :playing-live-stream="canPlayLiveStream"
      @audio-player:ready="onAudioPlayerReady"
      @audio:pause="onNowPlayingPause"
      @audio:play="onNowPlayingPlay"
      @episode-ended="onEpisodeEnded"
    >
    </now-playing-detail>
  </now-playing-section-layout>
</template>

<script>
import NowPlayingSectionLayout from './NowPlayingSectionLayout';
import NowPlayingImage from './NowPlayingImage';
import NowPlayingDetail from './NowPlayingDetail';
import { getLiveStreamUrl } from '../utils/utils';

const HOST =
  process.env.NODE_ENV === 'production'
    ? `//${location.host}`
    : '//post.futurimedia.com';

export default {
  name: 'now-playing-section',
  components: {
    NowPlayingSectionLayout,
    NowPlayingImage,
    NowPlayingDetail,
  },
  props: {
    station: String,
    showTitle: String,
    darkTheme: Boolean,
    episodeImages: Boolean,
    showImageSrc: String,
    activeEpisode: Object,
    compactOnMobile: Boolean,
    dropToLive: Boolean,
    useM4a: Boolean,
  },
  data() {
    return {
      rectangleImageWidth: 700,
      rectangleImageHeight: 366,
      squareImageWidth: undefined,
      squareImageHeight: undefined,
      liveStreamUrl: undefined,
      canPlayLiveStream: false,
    };
  },
  computed: {
    rootUrl() {
      return `${HOST}/${this.station.toLowerCase()}`;
    },
    showImageUrl() {
      // TODO: Implement real placeholder image url
      return this.showImageSrc
        ? `${HOST}${this.showImageSrc}`
        : `https://via.placeholder.com/${this.rectangleImageWidth}x${
            this.rectangleImageHeight
          }.png?text=${
            this.showTitle || (this.station ? this.station.toUpperCase() : '')
          }`;
    },
    nowPlayingImageSrc() {
      if (this.episodeImages) {
        return this.activeEpisode
          ? this.activeEpisode.image &&
              `${this.rootUrl}${this.activeEpisode.image}`
          : this.showImageUrl;
      }
      return this.showImageUrl;
    },
    episodeName() {
      return this.activeEpisode ? this.activeEpisode.name : undefined;
    },
    episodeDescription() {
      return this.activeEpisode ? this.activeEpisode.description : undefined;
    },
    m3u8Url() {
      return this.activeEpisode
        ? `${this.rootUrl}/playlist/${this.activeEpisode.id}.m3u8`
        : undefined;
    },
    m4aUrl() {
      return this.activeEpisode
        ? `${HOST}${this.activeEpisode.m4a_file}`
        : undefined;
    },
    episodeAudioFileSrc() {
      if (!this.canPlayLiveStream) {
        if (this.useM4a) {
          return this.m4aUrl;
        }
        return this.m3u8Url;
      }
      return this.liveStreamUrl;
    },
  },
  methods: {
    onAudioPlayerReady(audioPlayerRef) {
      this.$emit('audio-player:ready', audioPlayerRef);
    },
    onNowPlayingPause() {
      this.$emit('audio:pause');
    },
    onNowPlayingPlay() {
      this.$emit('audio:play');
    },
    onEpisodeEnded() {
      if (this.dropToLive) {
        getLiveStreamUrl(this.station)
          .then((url) => {
            this.liveStreamUrl = url;
            this.canPlayLiveStream = true;
          })
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.warn('Unable to fetch live stream', e);
          });
      }
    },
  },
  watch: {
    activeEpisode() {
      this.canPlayLiveStream = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// NowPlayingSection.vue?2db23cf6